import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { signInWithEmailAndPassword } from "firebase/auth";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { AuthLayout } from "@/components/auth/AuthLayout";
import { CheckCircle, CheckCircle2, Loader2 } from "lucide-react";
import { auth } from "../../data/firebase";
import { createUserAccountFunction } from "../../data/firebase";

export function PasswordStep() {
  const location = useLocation();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const email = location.state?.email || "";

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    setError("");
    setLoading(true);

    try {
      const result = await createUserAccountFunction({
        pendingAccountId: location.state?.pendingAccountId,
        password: password,
      });

      if (result.data.success) {
        // Sign in the user
        await signInWithEmailAndPassword(auth, email, password);
        navigate("/dashboard");
      }
    } catch (error) {
      setError("Failed to create account. Please try again.");
      console.error("Account creation error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <Card className="w-full max-w-sm">
        <CardHeader className="text-left">
          <CardTitle className="text-xl flex items-center gap-2 justify-center text-green-600">
            <CheckCircle2 className="size-6 text-green-600" />
            Free Trial Activated
          </CardTitle>
          {/* <CardDescription>Thank you for your purchase!</CardDescription> */}

          {/* <CardDescription>Secure your account with a password</CardDescription> */}
          {/* <CardDescription>
            Please set a password for your account before continuing
          </CardDescription> */}
        </CardHeader>
        <CardContent>
          <div className="grid gap-6">
            <div className="flex flex-col gap-0">
              <h3 className="text-lg font-semibold">Final step</h3>
              <p className="text-sm text-muted-foreground">
                Create a password for your account
              </p>
            </div>
            <div className="grid gap-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} disabled />
            </div>

            {error && (
              <div className="rounded-md bg-destructive/15 p-3 text-sm text-destructive">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="grid gap-4">
              <div className="grid gap-2">
                <Label htmlFor="password">Password</Label>
                <Input
                  id="password"
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className="grid gap-2">
                <Label htmlFor="confirm-password">Confirm Password</Label>
                <Input
                  id="confirm-password"
                  type="password"
                  required
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
              <Button type="submit" className="w-full" disabled={loading}>
                {loading ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    Please wait
                  </>
                ) : (
                  "Go to App"
                )}
              </Button>
            </form>
          </div>
        </CardContent>
      </Card>
      <div className="h-20"></div>
    </AuthLayout>
  );
}
